export default "__VITE_ASSET__g8E2QiQk__"